module.exports = __webpack_public_path__ + "static/media/scrollSlideRight.f4c95e49.svg";